module.exports = __webpack_public_path__ + "static/media/2DGACM2.c00e6958.jpg";